import React from 'react';

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const AppleLogo = ({ title = '', ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title || 'Apple'}</title>

      <path
        d="M15.4689 14.3169C15.1852 14.957 14.8495 15.5461 14.4604 16.0877C13.9301 16.8261 13.4959 17.3372 13.1613 17.621C12.6426 18.0869 12.0868 18.3255 11.4917 18.3391C11.0644 18.3391 10.5492 18.2203 9.94942 17.9795C9.34769 17.7397 8.7947 17.621 8.28906 17.621C7.75877 17.621 7.19003 17.7397 6.58169 17.9795C5.97243 18.2203 5.48162 18.3458 5.10636 18.3583C4.53565 18.382 3.9668 18.1366 3.39899 17.621C3.03658 17.3123 2.58328 16.7831 2.04025 16.0334C1.45762 15.2329 0.978617 14.3045 0.603357 13.2461C0.201466 12.1029 0 10.9959 0 9.92418C0 8.69652 0.271632 7.63768 0.815707 6.75037C1.2433 6.03765 1.81215 5.47544 2.52412 5.06271C3.23608 4.64999 4.00536 4.43967 4.8338 4.42621C5.2871 4.42621 5.88154 4.56314 6.62025 4.83226C7.35688 5.10229 7.82986 5.23922 8.03723 5.23922C8.19227 5.23922 8.7177 5.07911 9.60844 4.7599C10.4508 4.46386 11.1617 4.34129 11.7441 4.38957C13.3222 4.51396 14.5079 5.12151 15.2964 6.21609C13.885 7.05126 13.1868 8.22103 13.2007 9.72166C13.2134 10.8905 13.6476 11.8632 14.5009 12.6355C14.8877 12.994 15.3195 13.271 15.8 13.4677C15.6958 13.7629 15.5858 14.0456 15.4689 14.3169ZM11.8495 0.407497C11.8495 1.32365 11.5067 2.17905 10.8236 2.97081C9.99921 3.91205 9.00207 4.45595 7.92075 4.37012C7.90697 4.26021 7.89898 4.14454 7.89898 4.02298C7.89898 3.14348 8.29103 2.20223 8.98725 1.43264C9.33484 1.04298 9.7769 0.718986 10.313 0.460529C10.8479 0.205927 11.3539 0.065127 11.8298 0.0410156C11.8437 0.163491 11.8495 0.285973 11.8495 0.407485V0.407497Z"
        fill="#848F9D"
      />
    </svg>
  );
};

AppleLogo.propTypes = {
  title: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(AppleLogo);
